



import Vue from 'vue'
import Mailing from '@/models/mailing/mailing'
import statusComponent from '@/components/Newsletters/status.vue'

export default Vue.extend({
  name: 'TextColumn',
  props: {
    row: Object as () => Mailing
  },
  components: {
    statusComponent
  }
})
